module.exports = __webpack_public_path__ + "assets/youtube2.a51ab7ed.svg";